import { isEqual } from 'lodash';
import { Service } from 'model/Service';

export const hasBasePriceChanged = (originalService: Service | undefined, updatedService: Service): boolean => {
    if (!originalService || originalService.id === undefined) {
        return false;
    }

    const originalFixed = originalService.pricing.fixedPrice ?? [];
    const updatedFixed = updatedService.pricing.fixedPrice ?? [];

    if (!isEqual(originalFixed, updatedFixed)) {
        return true;
    }

    const originalVariable = originalService.pricing.variablePrice;
    const updatedVariable = updatedService.pricing.variablePrice;

    if ((originalVariable === undefined) !== (updatedVariable === undefined)) {
        return true;
    }

    if (originalVariable && updatedVariable) {
        return !isEqual(originalVariable, updatedVariable);
    }

    return false;
};
